import { createSlug } from "../../Utils/HelperFunctions";

/**
 * Open a sub-category listing, the way the rest of the app does it.
 *
 * A Browse chip is not a search — tapping "Kurtis" means "show me Kurtis", the
 * same as tapping it on the home page or in the nav drawer. So it leaves /search
 * for the canonical /shop/:vertical/:subcat/:id page instead of writing a
 * `?category=` filter onto the search URL.
 *
 * The sessionStorage write is load-bearing, not bookkeeping: HealthConcernList
 * reads `clickedHealthConcern` back as a GENDER hint (womens-fashion → women)
 * and puts it in the product query. Navigate without it and the same category
 * page returns a different product set depending on where you came from.
 *
 * This mirrors MyStore.openSub, NavDrawer.goCategory and StoreFooter.goCategory,
 * which are three hand-rolled copies of the same rule. Search deliberately does
 * not add a fourth — the two search call sites share this one. Folding the other
 * three in is a worthwhile follow-up, but not this change.
 */
export function openCategory(navigate, cat) {
  if (!cat?.id) return;
  // Absent only if a caller hands over a category that did not come from
  // nav_drawer; the route still resolves by :id, so a wrong slug self-corrects
  // rather than 404s.
  const vertical = cat.vertical || "uncategorized";

  setGenderHint(vertical);
  navigate(`/shop/${vertical}/${createSlug(cat.name)}/${cat.id}`);
}

/**
 * The gender-hint half of openCategory on its own, for a caller that renders a
 * real <Link> to the listing (the home "Sarees under ₹2,000" banner) and so
 * cannot hand navigation to openCategory. Call it from the link's onClick.
 */
export function setGenderHint(vertical) {
  if (vertical === "womens-fashion" || vertical === "mens-fashion")
    sessionStorage.setItem("clickedHealthConcern", vertical);
  else sessionStorage.removeItem("clickedHealthConcern");
}

/** The gender query value HealthConcernList derives from the same hint. */
export const genderForVertical = (vertical) =>
  vertical === "womens-fashion" ? "women" : vertical === "mens-fashion" ? "men" : "";

export default openCategory;
